import * as Yup from "yup";

/** Source of an operational carrier assignment change (Story 1 Track B). */
export type CarrierAssignmentSourceType =
  | "STATIC_LOAD_LANE"
  | "LOAD_BOARD"
  | "CITY_DISPATCH";

/**
 * Structured row from carrier_assignment_change_log.
 * Mirrors the Story 1 backend contract (reason fields nullable until Story 3).
 */
export interface CarrierAssignmentChangeLogItem {
  id: number | string;
  sourceType: CarrierAssignmentSourceType;
  sourceId?: string;
  division?: string;
  weekStartDate?: string;
  planId?: string | number;
  turnNumber?: string;
  previousCarrierNumber?: string | number | null;
  previousCarrierName?: string | null;
  newCarrierNumber?: string | number | null;
  newCarrierName?: string | null;
  reasonCode?: string | null;
  reasonDescription?: string | null;
  changedAt: string;
  modifiedBy: string;
}

export interface CarrierAssignmentChangeLogFilterModel {
  dateFrom?: string;
  dateTo?: string;
  sourceType?: CarrierAssignmentSourceType;
  search?: string;
  carrierNumber?: string;
}

export const CarrierAssignmentChangeLogFilterSchema: Yup.ObjectSchema<CarrierAssignmentChangeLogFilterModel> =
  Yup.object({
    dateFrom: Yup.string(),
    dateTo: Yup.string(),
    sourceType: Yup.mixed<CarrierAssignmentSourceType>(),
    search: Yup.string(),
    carrierNumber: Yup.string(),
  }).defined();
